import { render, staticRenderFns } from "./SystemIndex.vue?vue&type=template&id=0222fd0e"
import script from "./SystemIndex.vue?vue&type=script&lang=js"
export * from "./SystemIndex.vue?vue&type=script&lang=js"
import style0 from "./SystemIndex.vue?vue&type=style&index=0&id=0222fd0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports